export const BASE_URL = "";
export const USERS_URL = "/api/users";
export const IMAGES_URL = "/api/images";
export const EVENT_URL = "/api/events";
export const NEWS_URL = "/api/news";
export const UNIT_URL = "/api/unit";
export const POST_URL = "/api/posts";
export const DIRECTORY_DOCUMENT_URL = "/api/directory-document";
